<template>
    <app-layout title="Refund">
        <form @submit.prevent="handleSubmit">
            <page-header>
                <template #title>Credit Request</template>

                <template #actions>
                    <jet-tertiary-button
                        :href="`/orders/${order.id}`"
                    >
                        Cancel
                    </jet-tertiary-button>
                </template>
            </page-header>

            <div class="flex flex-col px-3 md:px-4 lg:px-8 gap-y-4">
                <refund-details
                    :form="form"
                    :order="order"
                    :isCreate=true
                    :refund=null
                />

                <refund-products 
                    :form="form"
                    :ordered_products="order_products"
                    :noImageReturnReasons="noImageReturnReasons"
                    :returnReasons="returnReasons"
                />
            </div>

            <div class="text-center py-24" >                
                <div class="flex justify-center gap-x-8">
                    <jet-button type="submit" class="leading-none" style="padding-left: 2rem; padding-right: 2rem; padding-top: 1rem; padding-bottom: 1rem; font-size: 1rem;">
                        Submit
                    </jet-button>
                </div>
            </div>
        </form>
    </app-layout>
</template>

<script>
import { useForm } from '@inertiajs/inertia-vue3';
import AppLayout from '@/Layouts/AppLayout.vue';
import PageHeader from '@/Layouts/partials/PageHeader.vue';
import RefundDetails from '@/Pages/Refund/Partials/RefundDetails.vue';
import JetButton from '@/Jetstream/Button';
import JetTertiaryButton from '@/Jetstream/TertiaryButton';
import RefundProducts from '@/Pages/Refund/Partials/RefundProducts.vue';

export default {
    setup(props) {
        const form = useForm({
            itemsToReturn: {},
            itemReason: {},
            qtyToAdd: {},
            itemImages: {},
            returnNote: {},
            receiptImage: null,
        })

        return { form }
    },

    props: [ 
        'order',
        'order_products',
        'noImageReturnReasons',
        'returnReasons'
    ],

    components: {
        AppLayout,
        PageHeader,
        RefundDetails,
        JetButton,
        JetTertiaryButton,
        RefundProducts,
    },

    data() {
        return {
            formRoute: this.route('refunds.store'),
        }
    },

    methods: {
        handleSubmit () {
            if(!this.form.processing){
                this.form
                    .transform((data) => ({
                        ...data,
                        token: this.order.refund_token,
                    }))
                    .post(route('refunds.store'));
            }
        },
        
        closeWindow() {
            window.close();
        },
    },
}
</script>

<style scoped>
.multi-custom {
    min-height: 1.5rem;
}
</style>
